import { ELEMENT_GESTURE_MOVABLE_CONTAINER } from '@components/ArtBoard/Canvas/hooks/events/useDragEvents'
import { buildCanvasEvent } from '@store/globalSaga'
import type { CanvasPayload } from '@store/globalSaga/types'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

export const useCanvas = () => {
  const activeTab = useSelector(migrationProjectSelector.getActiveOrFirstTabId)
  const ref = document.getElementById(ELEMENT_GESTURE_MOVABLE_CONTAINER)

  return (payload: Partial<CanvasPayload>) => {
    const event = buildCanvasEvent(ref, payload, activeTab)

    if (!event) {
      return
    }

    window.dispatchEvent(event)
  }
}
